module.exports = __webpack_public_path__ + "static/media/add-agent.a21234a9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/add-agent.svg
// module id = 1428
// module chunks = 0